import ajax from '@/utils/request'

// 获取公钥
export const reqGetCommonConfig = data => ajax('/api/config/getCommonConfig', data, 'GET')
// 获取加密公钥
export const getRsaPubKey = data => ajax('/api/config/getRsaPubKey', data, 'GET')
// 获取个人信息
export const getAdmin = data => ajax('/api/admins/get/online/admin', data, 'GET')
// 修改密码
export const changePassword = data => ajax('/api/admins/change/password', data, 'POST')
// 发送验证码 type：0邮箱注册 1手机注册 2邮件登录 3短信登录 4邮箱找回密码 5手机号找回密码
export const sendCode = data => ajax('/api/login/send/code', data, 'POST')
// 重置密码
export const resetPassword = data => ajax('/api/login/reset/password', data, 'POST')
// 登录
export const loginAPI = data => ajax('/api/login/doLogin', data, 'POST')
// 退出
export const signout = data => ajax('/api/login/signout', data, 'GET')
